// ═══════════════════════════════════════════════════════════════
//  EXPEDITION PORTFOLIO — MASTER CONTENT FILE
//  Every word & image on the site lives here. Edit freely:
//  - Swap the IMAGES urls with your own trek photography anytime
//  - Update copy, links, tags and lists below
// ═══════════════════════════════════════════════════════════════

export const IMAGES = {
  heroAvatar: "/hero-avatar.jpg",
  holderPhoto: "/images/holder.jpg",
  heroScene: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/db9ba11a1453ebae3dea0be294146a362e95f6793af07adfc70400a56b292713.jpeg",
  heroPeaks: "https://images.unsplash.com/photo-1759262987751-422c91923354?q=80&w=2400&auto=format&fit=crop",
  aboutSummit: "https://images.pexels.com/photos/28718279/pexels-photo-28718279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  aboutCamp: "https://images.unsplash.com/photo-1782236836440-3d3f2e619351?q=80&w=1200&auto=format&fit=crop",
  gearCompass: "https://images.unsplash.com/photo-1489619547086-641e1c87c3ff?q=80&w=1200&auto=format&fit=crop",
  packPhoto: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/8070909af7877dae0e6aca60bdd226fcd946e473b27357586eec0a455882462e.jpeg",
  noteTrek: "https://images.unsplash.com/photo-1759232273358-2fbe80987dc0?q=80&w=1200&auto=format&fit=crop",
  noteLadakh: "https://images.pexels.com/photos/11983992/pexels-photo-11983992.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  noteHiker: "https://images.unsplash.com/photo-1764685859493-a4b3cea53e79?q=80&w=1200&auto=format&fit=crop",
  notePhotographer: "https://images.pexels.com/photos/31348057/pexels-photo-31348057.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  project1: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/eec44848a38edd2c0859ea45f1c4aae379452d6dbd00cf92f87dae34ce9f9105.jpeg",
  project2: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/c115ee4a9180d48801e4c8c20e7287bfd1461363b7ca98b0b4814f63b949f893.jpeg",
  project3: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/c7b35a0bfdb0350d754cbbe6c65c48a46bc8b65654232b29c9c7f23a3c07980c.jpeg",
  project4: "https://static.prod-images.emergentagent.com/jobs/020f5f2c-6ef4-4420-9200-17ced18ad1df/images/705d9ba1819bc7fec198afd4502f8d9b53eddd4d8b4194552969003f7c4e4976.jpeg",
};

// Route stations — used by the nav and the fixed route HUD
export const SECTIONS = [
  { id: "hero", label: "BASE CAMP" },
  { id: "about", label: "ABOUT ME" },
  { id: "education", label: "EDUCATION" },
  { id: "experience", label: "WORK EX." },
  { id: "skills", label: "TOOLS & SKILLS" },
  { id: "projects", label: "PROJECTS" },
  { id: "instagram", label: "INSTAGRAM" },
  { id: "contact", label: "CONTACT" },
];

export const NAV_LINKS = SECTIONS;

// EDIT: Instagram station — your selected posts/reels, shown in this order.
// Cover images: add img:"/images/insta/<file>.webp" to a tile (files served from public/images/insta).
// Type: auto-detected from the link, but a /p/ link that is actually a reel needs type:"REEL" written here.
export const INSTAGRAM = {
  handle: "@standout_hiker",
  profile: "https://www.instagram.com/standout_hiker/",
  posts: [
    { url: "https://www.instagram.com/p/DZNSGPjTklI/", img: "/images/insta/1.webp" },
    { url: "https://www.instagram.com/p/DSfCl1WkVlG/", img: "/images/insta/2.webp", type: "REEL" },
    { url: "https://www.instagram.com/p/DIlmZUtTNKa/", img: "/images/insta/3.webp" },
    { url: "https://www.instagram.com/p/DXZgQlgEU0o/", img: "/images/insta/4.webp", type: "REEL" },
    { url: "https://www.instagram.com/p/DIJgAXgTM2H/", img: "/images/insta/5.webp", type: "REEL" },
    { url: "https://www.instagram.com/p/CoE5r0OLFYm/", img: "/images/insta/6.webp" },
    { url: "https://www.instagram.com/p/CzONqS2xaLx/", img: "/images/insta/7.webp" },
  ],
};

export const HERO = {
  eyebrow: "EXPEDITION DOSSIER — TREKKING THE HIMALAYA SINCE 2017",
  sub: "Turning ideas into creative visual experiences — work at the intersection of design, technology, creativity and exploration.",
};

export const ABOUT = {
  p1: "I'm a Graphic Designer, Web Designer and Creative Professional who enjoys turning ideas into creative visual experiences. My work combines design, websites, content and digital marketing.",
  p2: "I have a strong personal connection with the mountains. I've been trekking since 2017 and have completed 50+ Himalayan treks — including 2-3 expeditions — and have served as an Outdoor Leader with Indiahikes, gaining experience in trekking, leadership and expedition environments.",
  positioning: "My work sits at the intersection of design, technology, creativity and exploration — I take an idea and turn it into something visually engaging, functional and memorable.",
  stats: [
    { count: true, value: 50, suffix: "+", label: "HIMALAYAN TREKS" },
    { value: "2017", label: "TREKKING SINCE" },
    { value: "OUTDOOR", label: "LEADER — INDIAHIKES" },
  ],
};

export const EDUCATION = [
  { year: "2014", degree: "12th Standard", place: "Noida", note: "Trailhead — where the approach march began." },
  { year: "2017", degree: "B.Com (Hons.)", place: "New Delhi", note: "Camp I — foundations packed and secured." },
  { year: "2020", degree: "MBA", place: "New Delhi", note: "Base camp established — strategy in the pack." },
];

export const EXPERIENCE = [
  {
    id: "log01", period: "12/2018 — 01/2019", org: "Friends & Smile Foundation", role: "Marketing Intern", cat: "MARKETING & SEO",
    summary: "Completed a research study and submitted a report on educating the underprivileged.",
    tags: ["MARKETING RESEARCH", "FIELD STUDY", "REPORT WRITING", "SOCIAL IMPACT"],
  },
  {
    id: "log02", period: "04/2019 — 06/2019", org: "HRBOT (Skillmap.AI)", role: "Digital Marketing Intern", cat: "MARKETING & SEO",
    summary: "Developed a crowd-sourced recruiter partner network and provided training automation for remote recruiters.",
    tags: ["PARTNER NETWORK", "TRAINING AUTOMATION", "DIGITAL MARKETING", "RECRUITMENT"],
  },
  {
    id: "log03", period: "10/2021 — 05/2024", org: "Foal, LLC — USA", role: "Digital Marketing Executive", cat: "MARKETING & SEO",
    summary: "Handled on-page SEO, product listings and Amazon SEO; created social media posts; trained the team; delivered weekly and monthly SEO reporting.",
    tags: ["ON-PAGE SEO", "PRODUCT LISTINGS", "AMAZON SEO", "SOCIAL MEDIA POSTS", "TEAM TRAINING", "SEO REPORTING"],
  },
  {
    id: "log04", period: "11/2024 — 11/2025", org: "Indiahikes Private Limited", role: "Outdoor Leader", cat: "EXPEDITION",
    summary: "Led outdoor experiences with a strong focus on communication, people management and content storytelling to enhance community engagement and brand presence.",
    tags: ["LEADERSHIP", "COMMUNICATION", "PEOPLE MANAGEMENT", "CONTENT STORYTELLING", "COMMUNITY ENGAGEMENT", "BRAND PRESENCE"],
  },
  {
    id: "log05", period: "11/2025 — 04/2026", org: "Freelance", role: "Web Designer & Digital Creative", cat: "DESIGN & WEB",
    summary: "Developed a variety of websites for clients across industries — travel, restaurant, agency and more. Managed client Instagram accounts, creating regular, engaging posts.",
    tags: ["WEBSITE DESIGN", "CLIENT PROJECTS", "INSTAGRAM MANAGEMENT", "ENGAGING POSTS", "MULTI-INDUSTRY"],
  },
  {
    id: "log06", period: "07/2026 — PRESENT", current: true, org: "APL Apollo Limited", role: "Branding", cat: "MARKETING & SEO",
    summary: "Branding for one of APL Apollo's subsidiary brands — handling the website and social media, creating marketing material and designing creatives.",
    tags: ["BRAND MANAGEMENT", "WEBSITE", "SOCIAL MEDIA", "CREATIVES", "MARKETING MATERIAL"],
  },
];

export const SKILL_PACKS = [
  { id: "design", name: "Design", skills: ["Adobe Creative Suite & Canva", "Web Design", "UI Design", "Social Media Creatives"] },
  { id: "web", name: "Websites", skills: ["WordPress", "Shopify", "Elementor", "Google Analytics"] },
  { id: "growth", name: "Growth", skills: ["Ecommerce Listing", "SEO", "Product Catalogue"] },
  { id: "content", name: "Content", skills: ["Video Editing", "Visual Storytelling", "YouTube Management", "AI Tools & Exploration"] },
];

export const PROJECTS = [
  {
    id: "indiatripdrivers", wp: "WP-01 // INDIA", title: "India Trip Drivers",
    cat: "TRAVEL & TOURS", img: "/work/indiatripdrivers.jpg",
    coords: "20.59° N, 78.96° E", domain: "indiatripdrivers.com",
    url: "https://www.indiatripdrivers.com/",
    summary: "A complete travel platform designed from scratch — custom graphics, tour itineraries and every word of content written end to end.",
    scope: ["WEB DESIGN", "CUSTOM GRAPHICS", "TOUR ITINERARIES", "CONTENT WRITING"],
  },
  {
    id: "lets-secure", wp: "WP-02 // NEW ZEALAND", title: "Let's Secure",
    cat: "CCTV RENTALS & SECURITY", img: "/work/lets-secure.jpg",
    coords: "41.00° S, 174.00° E", domain: "cctvinstallation.co.nz",
    url: "https://cctvinstallation.co.nz/",
    summary: "A New Zealand CCTV rental business taken online — the entire website designed from scratch, with custom graphics, site structure and full content.",
    scope: ["WEB DESIGN", "CUSTOM GRAPHICS", "SITE STRUCTURE", "CONTENT WRITING"],
  },
  {
    id: "carbon-fusion", wp: "WP-03 // NOIDA, INDIA", title: "Carbon Fusion",
    cat: "PLASTIC RECYCLING", img: "/work/carbon-fusion.jpg",
    coords: "28.54° N, 77.39° E", domain: "thecarbonfusion.com",
    url: "https://thecarbonfusion.com/",
    summary: "Transforming plastic waste into sustainable value — a recycling workshop's website designed from scratch, with custom graphics, product listings and content.",
    scope: ["WEB DESIGN", "CUSTOM GRAPHICS", "PRODUCT LISTING", "CONTENT WRITING"],
  },
  {
    id: "rooh-gastronomy", wp: "WP-04 // GERMANY", title: "Rooh-Gastronomy",
    cat: "FINE DINING", img: "/work/rooh-gastronomy.jpg",
    coords: "51.17° N, 10.45° E", domain: "rooh-gastronomy.com",
    url: "https://rooh-gastronomy.com/",
    summary: "A Germany-based fine dining experience — designed from scratch with custom graphics, complete editorial content and dine-in integration.",
    scope: ["WEB DESIGN", "CUSTOM GRAPHICS", "DINE-IN INTEGRATION", "CONTENT WRITING"],
  },
];

// EDIT: Services & Packages — the four service routes shown in Station 07.
// Skills listed here are your real tools. No prices are shown anywhere (add a "price" field if you ever want one).
export const SERVICES = [
  {
    id: "srv-01", code: "SRV-01", icon: "Palette",
    title: "Brand & Visual Identity",
    description: "Logos, social media creatives and marketing material that give a brand one clear, consistent face — built in Adobe Creative Suite & Canva.",
    skills: ["Adobe Creative Suite & Canva", "Social Media Creatives", "UI Design"],
  },
  {
    id: "srv-02", code: "SRV-02", icon: "Layout",
    title: "Web Design & Build",
    description: "Websites designed and built from scratch — the same end-to-end work behind the four client dispatches in Station 06.",
    skills: ["Web Design", "WordPress", "Shopify", "Elementor"],
  },
  {
    id: "srv-03", code: "SRV-03", icon: "Video",
    title: "Content & Storytelling",
    description: "Video editing, visual storytelling and YouTube management — content that keeps people watching, made for the platforms you run.",
    skills: ["Video Editing", "Visual Storytelling", "YouTube Management"],
  },
  {
    id: "srv-04", code: "SRV-04", icon: "TrendingUp",
    title: "Growth & Visibility",
    description: "SEO, ecommerce listings and product catalogues — with Google Analytics to see what's actually working.",
    skills: ["SEO", "Ecommerce Listing", "Product Catalogue", "Google Analytics"],
  },
];

export const CONTACT = {
  name: "Amit Rawat",
  email: "amitsingh612@gmail.com",
  whatsapp: "919717053239",
  whatsappMessage: "Hi Amit! I came across your expedition portfolio and I'd like to discuss a project.",
  cvUrl: "/AMIT-RAWAT-RESUME.pdf",
  socials: [
    { label: "LinkedIn", url: "https://www.linkedin.com/in/amitrawat612/" },
    { label: "Instagram", url: "https://instagram.com/standout_hiker" },
  ],
};

// EDIT: placeholder testimonials — replace these with your real client quotes (names, roles and words).
export const TESTIMONIALS = [
  {
    id: "rep01",
    quote: "Amit rebuilt our entire website from scratch — design, graphics and content. Enquiries clearly went up after the new site went live.",
    name: "Rohit Negi",
    role: "Founder — India Trip Drivers",
  },
  {
    id: "rep02",
    quote: "Reliable, creative and fast. Our social media finally looks consistent, and the product listings he handles actually convert.",
    name: "Sarah Thompson",
    role: "Operations — Foal, LLC (USA)",
  },
  {
    id: "rep03",
    quote: "On the trail he keeps the team calm, organised and motivated — the same calm he brings to every design deadline.",
    name: "Prakash Rawat",
    role: "Fellow Outdoor Leader — Indiahikes",
  },
];
